export const addressLabels = {
    CA: {
        state: 'Province',
        zipCode: 'Postal Code',
    },
    USA: { state: 'State', zipCode: 'Zip' },
};

export const userDetailLabels = {
    CA: {
        yearOfCall: 'Year of Call (BC)',
    },
    USA: {
        yearOfCall: 'Admit Date',
    },
};

export const APPOINTMENT_SPECIFICATION = {
    QASE_SPECIFIC: 'Qase specific',
    SOURCE_SPECIFIC: 'Source specific',
};

export const APPOINTMENT_TYPES = {
    CASE_APPOINTMENT: 'Case appointment',
    INITIAL_CONSULTATION: 'Initial consultation',
    REFERRAL_APPOINTMENT: 'Referral Appointment',
};

export const LAWYER_LRS_STATUSES = {
    ACTIVE: 'Active',
    HOLD: 'Hold',
    STOP: 'Stop',
    ARCHIVE: 'Archive',
    PENDING_APPROVAL: 'Pending Approval',
};

export const LAWYER_LRS_STATUSES_OPTIONS = Object.entries(
    LAWYER_LRS_STATUSES,
).map(([key, value]) => {
    return {
        label: value,
        value: value,
    };
});

export const CASE_SIZE_OPTIONS = [
    { label: 'Medium', value: 'Medium' },
    { label: 'Large', value: 'Large' },
];

export const MEMBER_STATUSES = {
    ACTIVE: 'Active',
    NOT_RENEWED: 'Not Renewed',
    WAITING_FOR_RENEWAL: 'Waiting for Renewal',
};
export const MEMBER_STATUSES_OPTIONS = Object.entries(MEMBER_STATUSES).map(
    ([key, value]) => {
        return {
            label: value,
            value: value,
        };
    },
);

export const CASE_WAITING_STATUSES = {
    CLIENT_FOLLOW_UP: 'Client Follow Up',
    ATTORNEY_FOLLOW_UP: 'Attorney Follow Up',
    WAITING_ON_CLIENT: 'Waiting on Client',
    WAITING_ON_ATTORNEY: 'Waiting on Attorney',
    REVIEW: 'Review',
};

export const CASE_WAITING_STATUSES_OPTIONS = Object.entries(
    CASE_WAITING_STATUSES,
).map(([key, value]) => {
    return {
        label: value,
        value: value,
    };
});

export const REFERRAL_STAGE = {
    PENDING_REFERRAL: 'pending referral',
    REFERRAL: 'referral',
    LEAD: 'lead',
    MATTER: 'matter',
};

export const REFERRAL_STAGE_OPTIONS = Object.entries(REFERRAL_STAGE).map(
    ([key, value]) => {
        return {
            label: value,
            value: value,
        };
    },
);

export const REFERRAL_FEE_PAYMENT_SOURCE = {
    ONLINE: 'Online',
    NEW_PAYMENT: 'New Payment',
    AGENT_INTAKE: 'Agent Intake',
    MATTER_UPDATE: 'Matter Update',
};

export const APPOINTMENT_INITIATED_TYPES = {
    CLIENT: 'The client will call me',
    LAWYER: 'I will call the client',
};

export const BOOKING_LINK_STATUS = {
    PENDING: 'pending',
    COMPLETED: 'completed',
};

export const CASE_INITIATED_TYPES = {
    CLIENT: 'client',
    ATTORNEY: 'attorney',
    AGENT: 'agent',
    SYSTEM: 'system',
    SELF_BOOK: 'self-book',
    REFERRAL_REQUEST: 'referral-request',
    CLIENT_INTAKE: 'client-intake',
};
